import { useEffect, useRef, useMemo, useContext } from "react";
import { Bar } from 'react-chartjs-2';
import { barChartOptions, InitChart, verticalBarChartOptions } from "../config/chartconfig";
import { AdminContext } from "../contexts/AdminContext";
import { TITLE } from "../databases/spName";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(
    CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend
);



const RenderStatistics = () => {

    const chartRef = useRef(null)
    const { users } = useContext(AdminContext)

    useEffect(() => {
        InitChart()
    }, [])

    const roundSeatData = useMemo(() => {
        const labels = [...Object.values(TITLE.round.options)]
        const datasets = [
            {
                label: '-',
                data: [...Object.keys(TITLE.round.options)].map(round => {
                    return [...Object.keys(users)].filter(v => users[v].round === parseInt(round) && users[v].seatType === '-').length
                }),
                backgroundColor: '#f0f0f0',
            },
            {
                label: 'Economy',
                data: [...Object.keys(TITLE.round.options)].map(round => {
                    return [...Object.keys(users)].filter(v => users[v].round === parseInt(round)  && users[v].seatType === 'Economy').length
                }),
                backgroundColor: '#ffadd2',
            },
            {
                label: 'Business',
                data: [...Object.keys(TITLE.round.options)].map(round => {
                    return [...Object.keys(users)].filter(v => users[v].round === parseInt(round) && users[v].seatType === 'Business').length
                }),
                backgroundColor: '#b37feb',
            },
        ]
        return {labels, datasets}
    }, [users])

    const ageGenderData = useMemo(() => {
        const labels = ['<17', ...[...Array(19).fill(0)].map((v, i) => String(i + 17)), '>35']
        const datasets = [
            {
                label: 'หญิง',
                data: labels.map(age => {
                    if (!isNaN(age)) {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) === parseInt(age) : false) && ['MISS', 'MRS.'].includes(users[v].nameTitle) ).length
                    }
                    else if (age === '<17') {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) < 17 : false) && ['MISS', 'MRS.'].includes(users[v].nameTitle) ).length
                    }
                    else if (age === '>35') {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) > 35 : false) && ['MISS', 'MRS.'].includes(users[v].nameTitle) ).length
                    }
                    else {
                        return 0
                    }
                }),
                backgroundColor: '#ffa39e'//'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'ชาย',
                data: labels.map(age => {
                    if (!isNaN(age)) {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) === parseInt(age) : false) && ['MR.'].includes(users[v].nameTitle) ).length
                    }
                    else if (age === '<17') {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) < 17 : false) && ['MR.'].includes(users[v].nameTitle) ).length
                    }
                    else if (age === '>35') {
                        return [...Object.keys(users)].filter(v => (users[v].birth ?  2022 - parseInt(users[v].birth.split('-')[0]) > 35 : false) && ['MR.'].includes(users[v].nameTitle) ).length
                    }
                    else {
                        return 0
                    }
                }),
                backgroundColor: '#91d5ff',//'rgba(53, 162, 235, 0.5)',
            },
        ]
        return {labels, datasets}
    }, [users])

    const shengData = useMemo(() => {
        let a = {}
        for (const sh in TITLE.province.options) {
            a = {...a, [sh] : [...Object.keys(users)].filter(v => users[v].province === sh).length }
        }
        const labels = [...Object.keys(a)].sort((x, y) => a[x] > a[y] ? -1 : a[x] < a[y] ? 1 : 0)
        const datasets = [
            {
                label: '省',
                data: [...labels].map(sh => a[sh]),
                offset : true,
                backgroundColor : '#91d5ff'
            },
        ]
        return {labels, datasets}
    }, [users])

    const daxueData = useMemo(() => {
        let a = {}
        const maxLength = 40
        for (const keyname in users) {
            let dx = users[keyname].school
            if (dx in a && !isNaN(a[dx])) {
                a[dx] += 1
            }
            else {
                a[dx] = 1
            }
        }
        let sortedLabels = [...Object.keys({...a})].sort((x, y) => a[x] > a[y] ? -1 : a[x] < a[y] ? 1 : 0)
        let labels = sortedLabels.length > maxLength ? [...sortedLabels.slice(0, maxLength), '其他'] : sortedLabels
        let qt = 0
        if (sortedLabels.length > maxLength) {
            let qts = sortedLabels.slice(maxLength)
            qts.forEach(dx => qt += a[dx])
            a['其他'] = qt
        }
        const datasets = [
            {
                label: '学校',
                data: [...labels.map(sh => a[sh])],
                offset : true,
                backgroundColor : '#91d5ff'
            },
        ]
        return {labels, datasets}
    }, [users])

    const majorData = useMemo(() => {
        let a = {}
        const maxLength = 40
        for (const keyname in users) {
            let dx = users[keyname].major
            if (dx in a && !isNaN(a[dx])) {
                a[dx] += 1
            }
            else {
                a[dx] = 1
            }
        }
        let sortedLabels = [...Object.keys({...a})].sort((x, y) => a[x] > a[y] ? -1 : a[x] < a[y] ? 1 : 0)
        let labels = sortedLabels.length > maxLength ? [...sortedLabels.slice(0, maxLength), '其他'] : sortedLabels
        let qt = 0
        if (sortedLabels.length > maxLength) {
            let qts = sortedLabels.slice(maxLength)
            qts.forEach(dx => qt += a[dx])
            a['其他'] = qt
        }
        const datasets = [
            {
                label: '专业',
                data: [...labels.map(sh => a[sh])],
                offset : true,
                backgroundColor : '#91d5ff'
            },
        ]
        return {labels, datasets}
    }, [users])

    const degreeYearData = useMemo(() => {
        const labels = ['本科', '硕士', '博士', ]
        const sublabels = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级']
        const colors = ['#ffa39e', '#ffbb96', '#ffd591', '#ffe58f', '#fffb8f', '#eaff8f']
        const datasets = sublabels.map((nianji, index) => ({
            label: nianji,
            data: labels.map(degree => {
                return [...Object.keys(users)].filter(v => users[v].degree === degree && users[v].year === nianji ).length
            }),
            backgroundColor: colors[index],
        }))
        return {labels, datasets}
    }, [users])

    const doseData = useMemo(() => {
        const labels = ['第一剂', '第二剂', '第三剂', '第四剂', '第五剂', '第六剂' ]
        const sublabels = ['Sinovac / 科兴', 'Sinopharm / 国药', 'AstraZeneca / 阿斯利康', 'Pfizer / 辉瑞', 'Moderna / 莫德纳']
        const colors = ['#ffa39e', '#ffd591', '#91d5ff', '#d3adf7', '#b7eb8f']
        const datasets = sublabels.map((doseType, index) => ({
            label: doseType,
            data: labels.map((d, i) => {
                return [...Object.keys(users)].filter(v => users[v][`dose${i + 1}`] === doseType).length
            }),
            backgroundColor: colors[index],
        }))
        return {labels, datasets}
    }, [users])

    const doseOrderData = useMemo(() => {
        //const sublabels = ['Sinovac / 科兴', 'Sinopharm / 国药', 'AstraZeneca / 阿斯利康', 'Pfizer / 辉瑞', 'Moderna / 莫德纳']
        let a = {}
        for (const keyname in users) {
            let s = ''
            for (let i = 1; i < 9; i++) {
                if (users[keyname][`dose${i}`]) {
                    switch (users[keyname][`dose${i}`]) {
                        case 'Sinovac / 科兴': case 'Sinopharm / 国药':
                            s += 'เชื้อตาย, '
                            break;
                        case 'AstraZeneca / 阿斯利康':
                            s += 'ไวรัลเวกเตอร์, '
                            break;
                        case 'Pfizer / 辉瑞': case 'Moderna / 莫德纳':
                            s += 'mRNA, '
                            break;
                        default:
                            break;
                    }
                }
            }
            if (s) {
                if (s in a) {
                    a[s] += 1
                }
                else {
                    a[s] = 1
                }
            }
        }
        const labels = Object.keys({...a}).sort((x, y) => a[x] > a[y] ? -1 : a[x] < a[y] ? 1 : 0)
        const datasets = [
            {
                label: '疫苗',
                data: [...labels.map(pattern => a[pattern])],
                offset : true,
                backgroundColor : '#91d5ff'
            },
        ]
        return {labels, datasets}
    }, [users])



    return (
        <div>
            <div ref={chartRef} className='container-fluid d-none d-md-block' style={{maxWidth : '768px'}} >
                <div style={{ padding : '20px'}}>
                    <Bar options={barChartOptions('จำนวนคน-เที่ยวบิน')} data={roundSeatData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar options={barChartOptions('เพศ-อายุ')} data={ageGenderData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar height={300} options={verticalBarChartOptions('省')} data={shengData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar height={400} options={verticalBarChartOptions('大学')} data={daxueData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar height={400} options={verticalBarChartOptions('专业')} data={majorData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar options={barChartOptions('学位 - 年级')} data={degreeYearData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar options={barChartOptions('疫苗')} data={doseData} />
                </div>
                <br /><br />
                <div style={{ padding : '20px'}}>
                    <Bar height={400} options={verticalBarChartOptions('疫苗')} data={doseOrderData} />
                </div>
                <br /><br />
            </div>
            <div className="d-md-none">ขออภัย ขนาดหน้าจอเล็กเกินไป โปรดดูในคอมหรือแท็บเล็ต</div>
        </div>
    )
}

export default RenderStatistics;